import { Row, Button, Col, Popconfirm } from 'antd';

const GridPresupuestoObra = ({ lastBudget, iva, budget_iva, openModalBudgetFunc, deleteBudget }) => {

    const numberFormat = new Intl.NumberFormat('es-MX', {minimumFractionDigits: 2});
    const budgetIva = lastBudget * (budget_iva/100);
    const budgetIvaPlusIva = (iva/100) * budgetIva;
    const total = lastBudget + budgetIvaPlusIva;

    return (
        <>
            <Col xs={24} md={12}>
                <Row justify="space-between" align="middle" style={{ marginBottom: 12 }}>
                    <h4 className='title-custom'>PRESUPUESTO OBRA</h4>

                    <Popconfirm
                        title="¿Estás seguro de eliminar este control de presupuesto?"
                        okText="Sí"
                        cancelText="No"
                        onConfirm={() => deleteBudget()}
                    >
                        <Button
                            type="primary"
                            danger
                            shape="round"
                        >
                            Eliminar
                        </Button>
                    </Popconfirm>
                    <Button
                        type="default"
                        shape="round"
                        onClick={() => openModalBudgetFunc()}
                    >
                        Editar
                    </Button>
                </Row>

                <table style={{ width: "100%", borderSpacing: "0 6px" }}>
                    <tbody>
                    <tr>
                        <td style={{ color: "#98989A", fontWeight: 500 }}>Presupuesto obra:</td>
                        <td style={{ fontWeight: 600, width: "140px", textAlign: "right" }}>
                        $ {numberFormat.format(lastBudget) || "0.00"}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ color: "#98989A", fontWeight: 500 }}>IVA Presup. obra:</td>
                        <td style={{ fontWeight: 600, width: "140px", textAlign: "right" }}>
                        $ {numberFormat.format(budgetIvaPlusIva) || "0.00"}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ color: "#98989A", fontWeight: 500 }}>
                        Total presup. real obra:
                        </td>
                        <td style={{ fontWeight: 600, width: "140px", textAlign: "right" }}>
                        $ {numberFormat.format(total)}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </Col>
        </>
    )
}

export default GridPresupuestoObra;